{
  "components": {
    "columns": {
      "composition": "Composition",
      "reference": "Reference",
      "supplier": "Supplier"
    },
    "search": "Search any component by reference, composition or supplier."
  },
  "menus": {
    "businessPartners": "Business Partners",
    "components": "Components",
    "products": "Products"
  },
  "products": {
    "columns": {
      "collection": "Collection",
      "color": "Color",
      "dyeingCountry": "Dyeing Country",
      "mainFabric": "Main Fabric",
      "manufacturer": "Direct Supplier",
      "manufacturingCountry": "Manufacturing Country",
      "name": "Name",
      "qrCode": "AGEC page",
      "recycledMaterialPercentage": "Recycled material percentage",
      "reference": "Reference code",
      "releaseMicroplastics": "Releases microplastics",
      "weavingCountry": "Weaving Country"
    },
    "search": "Search any product by name, color, collection, etc.",
    "toggleAgecView": "Toggle AGEC view"
  },
  "title": "Library"
}
